import { Link } from "react-router-dom";
import { formatAddress } from "../../utils/format";

export default function ContractEvents({ events, decimals, symbol }) {
  // Ensure events is an array
  const eventsArray = Array.isArray(events) ? events : [];

  if (eventsArray.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">No events found for this contract</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {eventsArray.map((event, index) => (
        <div key={index} className="bg-gray-50 rounded-lg p-4 border">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center space-x-3">
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                {event.eventName || "Event"}
              </span>
              <span className="text-sm text-gray-500">
                Block #{event.blockNumber}
              </span>
            </div>
            <div className="text-sm text-gray-500">
              {new Date(event.timestamp).toLocaleString()}
            </div>
          </div>

          {event.extrinsicHash && (
            <div className="mb-2">
              <span className="text-sm font-medium text-gray-700">
                Transaction:{" "}
              </span>
              <Link
                to={`/extrinsics/${event.extrinsicHash}`}
                className="font-mono text-sm"
                style={{
                  color: "#00868A",
                  textDecoration: "none",
                  transition: "color 0.2s ease",
                }}
                onMouseEnter={(e) => (e.target.style.color = "#00A786")}
                onMouseLeave={(e) => (e.target.style.color = "#00868A")}
              >
                {formatAddress(event.extrinsicHash)}
              </Link>
            </div>
          )}

          {event.data && (
            <div className="mt-3">
              <h4 className="text-sm font-medium text-gray-700 mb-2">
                Event Data:
              </h4>
              <div className="bg-white rounded p-3 border">
                {typeof event.data === "object" ? (
                  <pre className="text-sm text-gray-700 whitespace-pre-wrap">
                    {JSON.stringify(event.data, null, 2)}
                  </pre>
                ) : (
                  <span className="text-sm text-gray-700">{event.data}</span>
                )}
              </div>
            </div>
          )}

          {event.topics && event.topics.length > 0 && (
            <div className="mt-3">
              <h4 className="text-sm font-medium text-gray-700 mb-2">
                Topics:
              </h4>
              <div className="space-y-1">
                {event.topics.map((topic, topicIndex) => (
                  <div
                    key={topicIndex}
                    className="font-mono text-xs text-gray-600 bg-white p-2 rounded border"
                  >
                    {topic}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
